// removed by extract-text-webpack-plugin
module.exports = {"searchNoResult":"_1BIDS"};